var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKebabMenu = function SvgKebabMenu(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 2.66732C6.66634 3.4037 7.26329 4.00065 7.99967 4.00065C8.73605 4.00065 9.33301 3.4037 9.33301 2.66732C9.33301 1.93094 8.73605 1.33398 7.99967 1.33398C7.26329 1.33398 6.66634 1.93094 6.66634 2.66732Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 8.00065C6.66634 8.73703 7.26329 9.33398 7.99967 9.33398C8.73605 9.33398 9.33301 8.73703 9.33301 8.00065C9.33301 7.26427 8.73605 6.66732 7.99967 6.66732C7.26329 6.66732 6.66634 7.26427 6.66634 8.00065Z",
    fill: "#595959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 14.6673C7.26329 14.6673 6.66634 14.0704 6.66634 13.334C6.66634 12.5976 7.26329 12.0007 7.99967 12.0007C8.73605 12.0007 9.33301 12.5976 9.33301 13.334C9.33301 14.0704 8.73605 14.6673 7.99967 14.6673Z",
    fill: "#595959"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKebabMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "kebabMenu.07fc631f7025899912b168ddf5bc8f73.svg";